/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import { IPromisedPaymentTranslation } from '../../types/modules/promisedPayments';

const initPromisedPaymentTranslation: IPromisedPaymentTranslation = {
    modal: {
        buttonMore: '',
        buttonSubmit: '',
        hint: '',
        text: '',
        textSuccess: '',
        title: '',
        titleError: '',
    },
    error: {
        codes: {},
        defaultMessage: '',
    },
}

export default initPromisedPaymentTranslation;
